<script setup lang="ts">
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  HomeIcon,
} from "@heroicons/vue/20/solid";
import { useHeaderData } from "~/composable/use.header-data";

const breadcrumbs = useHeaderData().breadcrumbs;
</script>

<template>
  <div
    class="py-4 bg-gradient-to-r from-black to-sky-900 mx-auto px-4 sm:px-6 lg:px-8"
  >
    <div>
      <nav class="sm:hidden" aria-label="Back">
        <a
          href="#"
          class="flex items-center text-sm font-medium text-white hover:text-white"
        >
          <ChevronLeftIcon
            class="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-500"
            aria-hidden="true"
          />
          Back
        </a>
      </nav>
      <nav class="hidden sm:flex" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div class="flex items-center">
              <a href="/" class="text-white hover:text-sky-600">
                <HomeIcon class="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                <span class="sr-only">Dashboard</span>
              </a>
            </div>
          </li>
          <li
            v-for="(breadcrumb, breadcrumbIdx) in breadcrumbs"
            :key="breadcrumbIdx"
          >
            <div class="flex items-center">
              <ChevronRightIcon
                class="h-5 w-5 flex-shrink-0 text-white"
                aria-hidden="true"
              />
              <a
                :href="breadcrumb.href"
                class="ml-4 text-sm font-medium text-white hover:text-sky-600"
                >{{ breadcrumb.label }}</a
              >
            </div>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<style scoped></style>
